import React, { useState } from "react";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
 import DataTable from "react-data-table-component";
import { SMsGatewayColumns } from "../../../data/master-settings/SMSList";
import { tableHeaderStyles } from "../../../styles/ReactSelectStyles";
import { InvoiceListColumn } from "../../../data/bills-payment/invoice/InvoiceList";
import { Link } from "react-router-dom";
import SearchBar from "../../../common-elements/search-bar/SearchBar";

export const InvoiceData = [
    {
      id: "1",
      organizationName: "Linnk",
      date: "01-07-2025",
      duedate: "10-07-2025",
      amount: "500",
      image: "dashboard-8/Linnk_Group_logo.png",
      invoiceItems: [
        { id: "1-1", item: "Premium Support", quantity: "2", price: "100", total: 200 ,tax:"15%",discount:"30"},
        { id: "1-2", item: "Software License", quantity: "3", price: "200", total: 600 ,tax:"15%",discount:"20"},
      ],
    },
    {
      id: "2",
      organizationName: "TechNova",
      date: "03-07-2025",
      duedate: "12-07-2025",
      amount: "750",
      image: "dashboard-8/eduspark.png",
    },
    {
      id: "3",
      organizationName: "SoftSync",
      date: "05-07-2025",
      duedate: "15-07-2025",
      amount: "620",
      image: "dashboard-8/eduspark.png",
    },
    {
      id: "4",
      organizationName: "CloudAxis",
      date: "08-07-2025",
      duedate: "18-07-2025",
      amount: "850",
      image: "dashboard-8/eduspark.png",
    },
    {
      id: "5",
      organizationName: "InfoLink",
      date: "10-07-2025",
      duedate: "20-07-2025",
      amount: "400",
      image: "dashboard-8/eduspark.png",
    }
  ];
function InvoiceList() {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  return (
    <div>
      <Breadcrumbs mainTitle={t("Invoice")} parent={t("BillsPayment")} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Search bar (left) */}
                    <SearchBar
                      label={t("Search")}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder={t("SearchByLeaveName")}
                    />
                    <div className="search-dropdown"></div>
                    
                      <Link
                        className="btn btn-primary"
                        to={`${process.env.PUBLIC_URL}/billingpayments/invoice/add`}
                      >
                        <i className="fa fa-plus" />
                        {t("Add")}
                      </Link>
                  </div>
                </div>

                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={InvoiceData}
                      columns={InvoiceListColumn(t)}
                      customStyles={tableHeaderStyles}
                      striped
                      highlightOnHover
                      pagination
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default InvoiceList;
